 <app-basic-shipping 
              #basicShippingComponent
             
              >
            </app-basic-shipping>